import { render, staticRenderFns } from "./CarPicture.vue?vue&type=template&id=c65bc87a&scoped=true&"
import script from "./CarPicture.vue?vue&type=script&lang=js&"
export * from "./CarPicture.vue?vue&type=script&lang=js&"
import style0 from "./CarPicture.vue?vue&type=style&index=0&id=c65bc87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65bc87a",
  null
  
)

export default component.exports